'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardFormsCtrl', ['$scope', '$state', 'Department', 'departments', 'dialog', 'forms', 'departmentReportConfig', 'Integration', '$translate','Authentication', '$uibModal', 'toast', require('./dashboardFormsCtrl')]);
app.directive('formUnit', [require('./dashboardFormsDirective')]);

app.directive('pendingValidateBadge', ['Form',require('../directives/pendingValidateBadge')]);
app.config(['$stateProvider', require('./dashboardFormsConfig')]);

app.controller('departmentReportConfigCtrl', ["$scope", "$state", "$uibModalInstance", "department", "ReportConfig", "BuilderDataService", "$translate", "toast", "departmentReportConfig", "Upload", "dialog", "$timeout", require('./departmentReportConfigCtrl')]);